// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"98119c25bc73657c8ea8","655":"ed9e31ead3fe666fe851"}[chunkId] + ".js";
};